var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _TaskPlannedJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import Store from "@ember-data/store";
import { service } from "@ember/service";
import JournalEvent from "core/models/abstract/planified-journal-event";
import Patient from "core/models/patient";
import TaskProcessedJournalEvent from "core/models/task-processed-journal-event";
import ParogService from "core/services/parog";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validateInclusion, validateNumber, validatePresence } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";
import { BaseTaskPlanned } from "./recursive-task-planned-journal-event";
import TreatmentHistoryChangedJournalEvent from "./treatment-history-changed-journal-event";
export let TaskType = /*#__PURE__*/function (TaskType) {
  TaskType["vitalSignsMeasurement"] = "vital-signs-measurement";
  TaskType["compoundSurvey"] = "compound-survey";
  TaskType["updatePatientBirthdayReminder"] = "update-patient-birthday-reminder";
  TaskType["patientInfo"] = "patient-info";
  return TaskType;
}({});

//---- Automatically generated, don't update this part ----
/**
 * Represents a task that has been planified.
 * A task is usually something to do in the application.
 */
let TaskPlannedJournalEvent = (_dec = attr("string"), _dec2 = attr("number"), _dec3 = attr("string"), _dec4 = attr("string"), _dec5 = attr("boolean", {
  allowNull: true
}), _dec6 = attr("string"), _dec7 = attr("date"), _dec8 = attr("string"), _dec9 = attr("string"), _dec10 = belongsTo("task-processed-journal-event", {
  async: false,
  inverse: "taskPlannedJournalEvent"
}), _dec11 = belongsTo("patient", {
  async: false,
  inverse: "taskPlannedJournalEvents"
}), _dec12 = belongsTo("treatment-history-changed-journal-event", {
  async: false,
  inverse: "taskPlannedJournalEvents"
}), _class = (_TaskPlannedJournalEvent = class TaskPlannedJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    /**
     * The type of the responsible. Could be null.
     */
    _initializerDefineProperty(this, "responsibleType", _descriptor, this);
    /**
     * The id of the responsible, could be null
     */
    _initializerDefineProperty(this, "responsibleId", _descriptor2, this);
    /**
     * An id describing the nature of the task.
     */
    _initializerDefineProperty(this, "taskType", _descriptor3, this);
    /**
     * An identifier to be able to link the task to a JournalEvent field (mainly used by TreatmentHistoryJournalEvent)
     */
    _initializerDefineProperty(this, "originTaskIdentifier", _descriptor4, this);
    /**
     * A boolean to remind the responsible to do the task
     */
    _initializerDefineProperty(this, "remindResponsible", _descriptor5, this);
    /**
     * A JournalEvent type that will process the task automatically after a JE creation. Could be a CompoundSurvey's id if the taskType is "compound-survey".
     * This should be written in snake case.
     * Example: 'weight-measured-journal-event'
     */
    _initializerDefineProperty(this, "processingJournalEventType", _descriptor6, this);
    /**
     * Date of the last HPRIM
     */
    _initializerDefineProperty(this, "lastHprimDate", _descriptor7, this);
    /**
     * A link to be redirected when click on the task
     */
    _initializerDefineProperty(this, "link", _descriptor8, this);
    /**
     * Models to pass to LinkTo component
     */
    _initializerDefineProperty(this, "models", _descriptor9, this);
    _initializerDefineProperty(this, "taskProcessedJournalEvent", _descriptor10, this);
    //---- End of generated code ----
    _initializerDefineProperty(this, "patient", _descriptor11, this);
    _initializerDefineProperty(this, "treatmentHistoryChangedJournalEvent", _descriptor12, this);
    _initializerDefineProperty(this, "store", _descriptor13, this);
    _initializerDefineProperty(this, "parog", _descriptor14, this);
  }
  static validations(intl) {
    return {
      taskType: validatePresence({
        presence: true,
        description: intl.t("validations.task-planned-journal-event.task-type")
      }),
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.task-planned-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée plus de 50 ans en avance. Veuillez modifier la date",
        onOrBefore: dayjs().add(50, "years").toDate()
      })],
      responsibleId: validateNumber({
        allowBlank: true,
        integer: true,
        description: intl.t("validations.task-planned-journal-event.responsible-id")
      }),
      responsibleType: validateInclusion({
        list: ["medic", "patient"],
        allowBlank: true,
        description: intl.t("validations.task-planned-journal-event.responsible-type")
      })
    };
  }
  get isVitalSignMeasurement() {
    return this.taskType == TaskType.vitalSignsMeasurement;
  }
  get isCompoundSurvey() {
    return this.taskType == TaskType.compoundSurvey;
  }
  get isPatientInfo() {
    return this.taskType == TaskType.patientInfo;
  }
  get kindOfLink() {
    return this.link ? this.link.startsWith("http") ? "external" : "internal" : undefined;
  }
  get hideOnTimeline() {
    return this.isProcessed;
  }
  get hasAvailablePatientType() {
    return Object.values(TaskType).includes(this.taskType);
  }
  get protocolName() {
    if (this.treatmentHistoryChangedJournalEvent && this.patient.healthCentre.oncoToulouse) {
      return this.originTaskIdentifier.split("_")[1];
    }
    return undefined;
  }
  async processTask(actionTaken, processOlderTasks = false) {
    if (this.isProcessed) {
      throw `The processed task '${this.id}' can't be processed again.`;
    }
    const taskProcessedJournalEvent = await this.store.createRecord("task-processed-journal-event", {
      patient: this.patient,
      occurredAt: new Date(),
      taskPlannedJournalEvent: this,
      actionTaken,
      processOlderTasks
    }).save();
    return taskProcessedJournalEvent;
  }

  /**
   * Shift the JE for the given amount of time.
   * Will archive this one and create a new one with a new 'occurredAt'.
   * @param number - The number of unit we want to shift the date of
   * @param periodStr - A string representing a unit of measurement for 'dayjs'.
   * Like 'days', 'months', 'years' ...
   */
  async shift(number, periodStr) {
    const hoursJE = dayjs(this.occurredAt).get("hour");
    const minutesJE = dayjs(this.occurredAt).get("minute");
    return await this.shiftAt(dayjs().add(number, periodStr).set("hour", hoursJE).set("minute", minutesJE).toDate());
  }

  /**
   * Archive this JE and create a new one at the new 'occurredAt'
   * @param occurredAt
   */
  async shiftAt(occurredAt) {
    if (this.isProcessed) {
      throw `The processed task '${this.id}' can't be shifted.`;
    }
    this.occurredAt = occurredAt;
    return this.save();
  }
  get isProcessed() {
    return Boolean(this.taskProcessedJournalEvent);
  }
  get icon() {
    return "bio";
  }
  get taskLabel() {
    return this.intl.t(`task.types.${this.taskType}`);
  }
}, _defineProperty(_TaskPlannedJournalEvent, "type", "task-planned-journal-event"), _TaskPlannedJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "responsibleType", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "responsibleId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "taskType", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "originTaskIdentifier", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "remindResponsible", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "processingJournalEventType", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "lastHprimDate", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "link", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "models", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "taskProcessedJournalEvent", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "treatmentHistoryChangedJournalEvent", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "parog", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TaskPlannedJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.